import { render, staticRenderFns } from "./version-popup.vue?vue&type=template&id=36e3618e&scoped=true"
import script from "./version-popup.vue?vue&type=script&lang=js"
export * from "./version-popup.vue?vue&type=script&lang=js"
import style0 from "./version-popup.vue?vue&type=style&index=0&id=36e3618e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3618e",
  null
  
)

export default component.exports